import { BreadCrumbBase } from 'src/legacy/components/UI/BreadCrumbBase';

type Props = {
  fileName: string;
};

export const SignaturePageBreadcrumbs = ({ fileName }: Props) => (
  <BreadCrumbBase
    items={[
      {
        label: ` eSignature request: ${fileName}`,
        textTransform: 'none',
      },
    ]}
  />
);
